import { passkeyClient } from '@better-auth/passkey/client';
import { twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

/** Same origin: the API lives under /api on the host that serves the app. */
export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [passkeyClient(), twoFactorClient()],
});

/** Better Auth returns { data, error }; turn an error into a thrown message. */
type Result = { data?: unknown; error?: { message?: string | undefined; status?: number | undefined } | null };

export async function must<R extends Result>(p: Promise<R>): Promise<NonNullable<R['data']>> {
  const res = await p;
  if (res.error) throw new Error(res.error.message || `Something went wrong (${res.error.status ?? 'no status'}).`);
  return res.data as NonNullable<R['data']>;
}
